import { useTranslation } from "react-i18next";
import { AlertTriangle, Award, BarChart3, Boxes, ClipboardList, LineChart, ShoppingCart,
         TrendingUp, Users } from "lucide-react";

const CHIPS = [
  ["period", BarChart3, "text-sky-600 bg-sky-500/10"],
  ["statement", Users, "text-emerald-600 bg-emerald-500/10"],
  ["aging", AlertTriangle, "text-destructive bg-destructive/10"],
  ["orders_summary", ShoppingCart, "text-amber-600 bg-amber-500/10"],
  ["price_compare", TrendingUp, "text-teal-600 bg-teal-500/10"],
  ["brand_compare", Award, "text-violet-600 bg-violet-500/10"],
  ["top_items", Boxes, "text-indigo-600 bg-indigo-500/10"],
  ["performance", LineChart, "text-lime-600 bg-lime-500/10"],
];

// شرائح اختيار التقرير (8 تقارير) بأيقونة ولون لكل تقرير.
export const ReportChips = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="-mx-1 overflow-x-auto pb-1" data-testid="report-chips">
      <div className="flex min-w-max items-center gap-2 px-1">
        {CHIPS.map(([key, Icon, tone]) => (
          <button
            key={key}
            type="button"
            data-testid={`report-chip-${key}`}
            onClick={() => onChange(key)}
            className={`tab-chip flex items-center gap-2 whitespace-nowrap rounded-2xl px-4 py-2.5 text-xs font-bold transition-all duration-300 hover:-translate-y-0.5 ${
              value === key ? `${tone} shadow-neu-in scale-[1.02]` : "text-muted-foreground shadow-neu-sm"
            }`}
            style={{ animationDelay: `${CHIPS.findIndex(([k]) => k === key) * 45}ms` }}
          >
            <Icon className="h-4 w-4" />
            {t(`purchases.reports.${key}`)}
          </button>
        ))}
      </div>
    </div>
  );
};

export const REPORT_KEYS = CHIPS.map(([key]) => key);
export const NEEDS = {
  period: ["from_date", "to_date"],
  statement: ["from_date", "to_date", "supplier"],
  aging: ["as_of"],
  orders_summary: ["from_date", "to_date"],
  price_compare: ["from_date", "to_date"],
  brand_compare: ["from_date", "to_date"],
  top_items: ["from_date", "to_date"],
  performance: ["from_date", "to_date"],
};

export { ClipboardList };
